<template>
  <div class="container">
    <div id="print_invoice">
      <div class="ticket-container">
        <div v-if="showOrderReceipt" class="ticket">
               <hr class="mt-5" />
               <div class="text-center">
                <h3>Kitchen Order</h3>
                  <h2>Order Number: {{ order.order }}</h2>
             </div>

          <p>Date: {{ formatDate(order.order.created_at,'DD-MM-Y')}}</p>
          <p>Time: {{ formatDate(order.order.created_at,'hh:mm A') }}</p>
          <hr class="my-1" />

          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="quantity">QTY</th>
                <th class="description">Description</th>


              </tr>
            </thead>
            <tbody>

              <tr v-if="!item.kitchen_status" v-for="item in orderitems" :key="item.id">
                <td class="quantity">{{ item.qty }}</td>
                <td class="description">



                           {{ item.product ? item.product.product : (item.grouped_inventory ? item.grouped_inventory.group_title : 'N/A') }}
                            <template v-if="item.grouped_inventory">
                            <p v-if="item.grouped_inventory.grouped_items && g_item.product.can_be_sold" v-for="g_item in item.grouped_inventory.grouped_items">
                                <small v-if="g_item.product">{{ g_item.product.product }} - {{ g_item.count }}</small>
                                <small v-else class="text-danger">Item could be missing</small>
                            </p>
                            </template>






                </td>


                <!-- (item.product ? ((item.selling_price !== null ) ? item.selling_price : item.product.ppu) -->



                </tr>


              <tr>
                <td class="totals" colspan="3"><b>({{ totalQuantity }}) - Ttl QTY</b></td>
                <td class="totals"></td>
              </tr>

            </tbody>
          </table>
            <p class="text-justify">
            Order by:
            <span class="text-capitalize" v-if="user.full_name === null">{{ order.soldby.name }}</span>
            <span class="text-capitalize" v-else>{{ order.soldby.name }}</span>
          </p>

        </div>
        <div v-else class="ticket">
          <div v-if="user.company !== ''" class="text-center">
            <img
              v-if="user.company.logo_url !== null"
              class="centered"
              :src="user.company.logo_url"
              style="width: auto; height: auto; max-height:120px"
              alt="Logo"
            />
            <p v-else class="centered">Logo</p>
          </div>
          <p class="centered text-center" v-if="user.company !== ''">
            <span class="company-details">{{ user.company.name }}</span>
            <span v-if="user.company.phone !== null"><br />Phone: {{ user.company.phone }}</span>
            <span v-if="user.company.email !== null"><br />Email: {{ user.company.email }}</span>
            <span v-if="user.company.address !== null"><br />Address: {{ user.company.address }}</span>
            <span v-if="user.company.building !== null"><br />Location: {{ user.company.building }}</span
            ><span v-if="user.company.street !== ''">{{ user.company.street }}</span>
            <span v-if="user.company.town !== null"><br />Town: {{ user.company.town }}</span>
            <span v-if="user.company.krapin !== null"><br />PIN: {{ user.company.krapin }}</span>
          </p>
          <div v-if="order.customer">
            <hr class="my-1" />
            <h6>Bill To:</h6>


            <p>Name: {{ order.customer.full_name }}</p>
            <p v-if="order.customer.phone">Phone: {{ order.customer.phone }}</p>
            <p v-if="order.customer.email">Email: {{ order.customer.email }}</p>

          </div>


          <hr class="my-1" />
          <p>Order Number: {{ order.order }}</p>
          <p>Date: {{ formatDate(order.order.created_at,'DD-MM-Y')}}</p>
          <p>Time: {{ formatDate(order.order.created_at,'hh:mm A') }}</p>
          <hr class="my-1" />

          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="quantity">QTY</th>
                <th class="description">Description</th>
                <th class="price">{{ userDetails.company.companysettings.currency }}</th>
                <th class="totals">Totals</th>
              </tr>
            </thead>
            <tbody>

              <tr v-for="item in orderitems" :key="item.id">
                <td class="quantity">{{ item.qty }}</td>
                <td class="description">



            {{ item.product ? item.product.product : (item.grouped_inventory ? item.grouped_inventory.group_title : 'N/A') }}
            <template v-if="item.grouped_inventory">
              <p v-if="item.grouped_inventory.grouped_items && g_item.can_be_sold" v-for="g_item in item.grouped_inventory.grouped_items">
                <small v-if="g_item.product">{{ g_item.product.product }} - {{ g_item.count }}</small>
                <small v-else class="text-danger">Item could be missing</small>
              </p>
            </template>



                </td>


                <!-- (item.product ? ((item.selling_price !== null ) ? item.selling_price : item.product.ppu) -->
                <td v-if="item.product" class="price">
                  {{ item.is_retail === 1 ?
                    (item.selling_price !== null ? item.selling_price : item.product.ppu) :
                    (item.selling_price !== null ? item.selling_price : item.product.wholesale_sp) }}
                </td>

                <td v-else class="price">
                  {{ item.is_retail === 1 ?
                    (item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.cost : 'N/A')) :
                    (item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.wholesale : 'N/A')) }}
                </td>

                <td v-if="item.product" class="price">
                  {{ item.is_retail === 1 ?
                    ((item.selling_price !== null ? item.selling_price : item.product.ppu) * item.qty) :
                    ((item.selling_price !== null ? item.selling_price : item.product.wholesale_sp) * item.qty) }}
                </td>

                <td v-else class="price">
                  {{ item.is_retail === 1 ?
                    ((item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.cost : 0)) * item.qty) :
                    ((item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.wholesale : 0)) * item.qty) }}
                </td>


                </tr>


              <tr>
                <td class="totals" colspan="3"><b>({{ totalQuantity }}) - Ttl QTY</b></td>
                <td class="totals"></td>
              </tr>
              <tr v-if="order.discount !==null">
                <td class="totals" colspan="3"><b>Discount</b></td>
                <td class="totals">{{ order.discount }}</td>
              </tr>
              <tr>
                <td class="totals" colspan="3"><b>Sub Total</b></td>
                <td class="totals" v-if="storeSettings.enable_taxes">{{ (order.total_amount / 1.16).toFixed(0) }}</td>
                <td class="totals" v-else>{{ order.total_amount }}</td>
              </tr>
              <tr v-if="storeSettings.enable_taxes">
                <td class="totals" colspan="3">VAT (16%)</td>
                <td class="totals">{{ order.total_amount - (order.total_amount / 1.16).toFixed(0) }}</td>
              </tr>
              <tr v-if="order.partial && order.balance > 0">
                <td class="totals" colspan="3">Balance</td>
                <td class="totals">{{ order.balance }}</td>
              </tr>
              <tr>
                <td class="totals" colspan="3"><b>Total</b></td>
                <td class="totals">{{ order.total_amount }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="order.partial && order.balance > 0">
            <h1 class="text-center text-danger">NOT CLEARED</h1>
          </div>
          <div v-if="order.paymentmethod">
            <h5>Payment</h5>
            <p>Payment:{{order.paymentmethod.payment_method  }}</p>
            <p>Amount:{{order.total_amount  }}</p>

          </div>
          <hr />
          <h5>Notes</h5>
                            <ul class="list-group">
                                <li v-if="note.on_receipt" class="list-group-item" v-for="note in order.ordernotes">{{ note.note }}</li>
                            </ul>
          <hr />
          <p class="text-justify">
            You were served by:
            <span class="text-capitalize" v-if="user.full_name === null">{{ order.soldby.name }}</span>
            <span class="text-capitalize" v-else>{{ order.soldby.name }}</span>
          </p>
          <hr />
          <p class="text-justify" v-if="user.company !== ''" v-html="user.company.configs"></p>
        </div>
      </div>
      <div class="container text-center">

                 <div class="btn-group px-2">
                            <a  href="/makesale" class="btn btn-primary"><i class="bi bi-cart"></i> Make a sale</a>

                           <button   v-if="!bluetoothPrinter.characteristic" class="btn btn-secondary" @click="connectToPrinter"><i class="bi bi-printer"></i> Connect to Bluetooth Printer</button>
                           <button  v-else class="btn btn-secondary" @click="printReceipt"><i class="bi bi-printer"></i>>Print via bluetooth</button>
                            <button   v-if="!bluetoothPrinter.characteristic" @click="printInvoice" class="btn btn-primary print-action"> Print Receipt</button>

                            <!-- <a class="btn btn-outline-secondary btn-sm px-2" style="color: #28D146;" target="_blank"  v-if="order_id.customer &&order_id.customer.phone" :href='"https://wa.me/" + convertToInternational(order_id.customer.phone) + "?text=Hello,%20Please%20see%20order%20from%20"+ userDetails.company.name +"%20https://app.dukakit.com/customer-order-view/" + order_id.id + "?from=whatsapp&utm=whatsapp"'  ><i class="bi bi-whatsapp"></i> </a> -->

                        </div>

        <p v-if="bluetoothPrinter.status">Bluetooth printer {{ bluetoothPrinter.status }}</p>

      </div>
    </div>
  </div>

  </template>

  <script>
  import axios from "axios";
  import {mapGetters} from 'vuex'


  export default {
    name: "invoice",
    props: ["order", "orderitems", "user"],

    data() {
      return {
        storeSettings: {},
        bluetoothPrinter: {
        device: null,
        server: null,
        service: null,
        characteristic: null,
        status: "Not connected",
        printerServiceUUID: "000018f0-0000-1000-8000-00805f9b34fb",
        printerCharacteristicUUID: "00002af1-0000-1000-8000-00805f9b34fb",
      },
      };
    },
    computed: {

         ...mapGetters(['userDetails']),
        totalQuantity() {
            if (this.orderitems && this.orderitems.length > 0) {
            return this.orderitems.reduce((accumulator, item) => accumulator + item.qty, 0);
            }
            return 0;
        },
                showOrderReceipt() {
                const params = new URLSearchParams(window.location.search);
                return params.get("order-receipt") === "true";
            }

},
    mounted() {
      this.getStoreSettings();
    },

    methods: {
async printInvoice() {
  let base64Logo = '';
  let resizedLogo = '';

  // Defensive check to ensure `user`, `company`, and `logo_url` exist
  if (
    this.user &&
    this.user.company &&
    this.user.company.logo_url &&
    this.user.company.logo_url.trim() !== ''
  ) {
    try {
      const encoded = encodeURIComponent(this.user.company.logo_url);
      const proxyUrl = `/api/proxy-logo?remote_url=${encoded}`;

      base64Logo = await this.fetchImageAsBase64(proxyUrl);

      if (base64Logo) {
        resizedLogo = await this.resizeImage(base64Logo, 300);
      }
    } catch (error) {
      console.error('Error fetching or resizing logo:', error);
      // Optional: Load a default logo
      // resizedLogo = await this.fetchImageAsBase64('/default-logo.png');
    }
  }

  // Even if no logo was provided or resizing failed, continue printing
  const content = this.generatePrintContent(resizedLogo); // Pass '' if no logo
  this.printContent(content);
},
resizeImage(base64, maxWidth = 300) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = maxWidth / img.width;
      const canvas = document.createElement("canvas");
      canvas.width = maxWidth;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = reject;
    img.src = base64;
  });
},
      async connectToPrinter() {
      try {
        this.bluetoothPrinter.status = "Requesting device...";
        this.bluetoothPrinter.device = await navigator.bluetooth.requestDevice({
          filters: [{ services: [this.bluetoothPrinter.printerServiceUUID] }],
        });

        this.bluetoothPrinter.status = "Connecting to GATT server...";
        this.bluetoothPrinter.server = await this.bluetoothPrinter.device.gatt.connect();

        this.bluetoothPrinter.status = "Getting printer service...";
        this.bluetoothPrinter.service = await this.bluetoothPrinter.server.getPrimaryService(
          this.bluetoothPrinter.printerServiceUUID
        );

        this.bluetoothPrinter.status = "Getting printer characteristic...";
        this.bluetoothPrinter.characteristic = await this.bluetoothPrinter.service.getCharacteristic(
          this.bluetoothPrinter.printerCharacteristicUUID
        );

        this.bluetoothPrinter.status = "Connected to printer!";
      } catch (error) {

        this.bluetoothPrinter.status = "Connection failed. Try again.";
      }
    },

    async printReceipt() {
    if (!this.bluetoothPrinter.characteristic) {
        this.bluetoothPrinter.status = "Printer not connected!";
        return;
    }

    try {
        const receiptText = this.generatePrintContentBluetooth();



        const encoder = new TextEncoder('UTF-8');

        const data = encoder.encode(receiptText);

        const chunkSize = 100; // Max safe chunk size
        for (let i = 0; i < data.length; i += chunkSize) {
            let chunk = data.slice(i, i + chunkSize);
            await this.bluetoothPrinter.characteristic.writeValue(chunk);
        }

        this.bluetoothPrinter.status = "Receipt printed successfully!";
    } catch (error) {

        this.bluetoothPrinter.status = "Failed to print.";
    }
},

      generatePrintContent(base64Logo) {
  const company = this.user.company;

  console.log(base64Logo)

  let content = `
    <html>
    <head>
      <style>
        * {
          box-sizing: border-box;
        }
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 10px;
          line-height: 1.4;
        }
        .container {

          margin: 0 auto;
        }
        .text-center {
          text-align: center;
        }
        .text-justify {
        text-align: justify !important;
      }
        .logo {
          text-align: center;
          margin-bottom: 10px;
        }
        .text-capitalize {
  text-transform: capitalize !important;
}
        .logo img {
          max-width: 120px;
          max-height: 120px;
        }
        .order-number {
          margin-bottom: 10px;
        }
        .table {
          width: 100%;
          margin-bottom: 10px;
        }
        .table th,
        .table td {
          padding: 5px;
          text-align: left;
        }
        .table th,tr {
          border-bottom: 1px solid #000;
          font-weight: normal;
        }

        .totals-row {
          font-weight: normal;
        }
        .bold {
          font-weight: 900;
        }
        .footer {
          margin-top: 10px;
          text-align: center;
        }
      </style>
    </head>
    <body>
      <div class="container">
  `;
if(!this.showOrderReceipt){
  if (company !== '' ) {
    content += `
     <div class="logo text-center">
          ${`<img src="${base64Logo}" alt="Logo"/>`}
        </div>
      <p class="text-center">
        <span class="bold">${company.name}</span><br />
        ${company.phone ? `Phone: ${company.phone}<br />` : ''}
        ${company.email ? `Email: ${company.email}<br />` : ''}
        ${company.address ? `Address: ${company.address}<br />` : ''}
        ${company.building ? `Location: ${company.building}<br />` : ''}
        ${company.street ? `${company.street}<br />` : ''}
        ${company.town ? `Town: ${company.town}<br />` : ''}
        ${company.krapin ? `PIN: ${company.krapin}` : ''}
      </p>
      <hr />
    `;
  }
  if (this.order.customer) {
    content += `
  <div>
            <hr class="my-1" />
            <h6>Bill To:</h6>


            <p>Name: ${ this.order.customer.full_name }</p>
            <p>Phone: ${this.order.customer.phone ? this.order.customer.phone :'' }</p>
            <p>Email:${ this.order.customer.email ? this.order.customer.email :'' }</p>

          </div>`
        }
  content += `
    <div class="order-number">
      Order Number: ${this.order.order}<br/>
      <hr />
      Date: ${moment(this.order.created_at).format('D-MM-Y')}</br>

      Time: ${moment(this.order.created_at).format('h:m a')}</br>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th class="quantity">QTY</th>
          <th class="description">Description</th>
          <th class="price">${this.userDetails.company.companysettings.currency}</th>
          <th class="totals">Totals</th>
        </tr>
      </thead>
      <tbody>
  `;



  this.orderitems.forEach((item) => {
  content += `
    <tr>
      <td><p>${item.qty}</p></td>
      <td>
        <p>${item.product ? item.product.product : (item.grouped_inventory ? item.grouped_inventory.group_title : 'N/A')}</p>
        ${
          item.grouped_inventory && item.grouped_inventory.grouped_items  ?
          item.grouped_inventory.grouped_items
          .filter(g_item => g_item.product && g_item.product.can_be_sold)
          .map((g_item) => {
            return `
              <p><small>${g_item.product ? g_item.product.product : ''} - ${g_item.count ? g_item.count : ''}</small></p>
            `;
          }).join('') :
          ''
        }
      </td>
      <td><p>${
        item.product ?
        (item.is_retail === 1 ? (item.selling_price !== null ? item.selling_price : item.product.ppu) : (item.selling_price !== null ? item.selling_price : item.product.wholesale_sp)) :
        (item.is_retail === 1 ? (item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.cost : 'N/A')) : (item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.wholesale : 'N/A')))
      }</p></td>
      <td><p>${
        item.product ?
        ((item.is_retail === 1 ? (item.selling_price !== null ? item.selling_price : item.product.ppu) : (item.selling_price !== null ? item.selling_price : item.product.wholesale_sp)) * item.qty).toFixed(2) :
        ((item.is_retail === 1 ? (item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.cost : 0)) : (item.selling_price !== null ? item.selling_price : (item.grouped_inventory ? item.grouped_inventory.wholesale : 0))) * item.qty).toFixed(2)
      }</p></td>
    </tr>
    <tr>
      <td colspan="4" style="border-top: 1px dashed #000;"></td>
    </tr>
  `;
});




  const subtotal = this.order.total_amount / (this.storeSettings.enable_taxes ? 1.16 : 1);
  const vat = this.order.total_amount - subtotal;

  content += `
      </tbody>
      <tfoot>
        <tr class="totals-row">
        <td colspan="3">${this.totalQuantity} - Total QTY</td>
        <td></td>
      </tr>`;
        if (this.order.discount !=null) {
    content += `
      <tr class="totals-row">
        <td colspan="3">Discount</td>
        <td>${this.order.discount.toFixed(2)}</td>
      </tr>
    `;
  }
  content += ` <tr class="totals-row">
          <td colspan="3"><b>Sub Total</b></td>
          <td>${subtotal.toFixed(2)}</td>
        </tr>
  `;

  if (this.storeSettings.enable_taxes) {
    content += `
      <tr class="totals-row">
        <td colspan="3">VAT (16%)</td>
        <td>${vat.toFixed(2)}</td>
      </tr>
    `;
  }

  if (this.order.partial && this.order.balance > 0) {
    content += `
      <tr class="totals-row">
        <td colspan="3">Balance</td>
        <td>${this.order.balance.toFixed(2)}</td>
      </tr>
    `;
  }


  content += `
      <tr class="totals-row">
        <td colspan="3"><b>Total</b></td>
        <td>${this.order.total_amount.toFixed(2)}</td>
      </tr>
    </tfoot>
  </table>
  `;

  if (this.order.partial && this.order.balance > 0) {
    content += `
      <div class="text-center text-danger">
        <h1>NOT CLEARED</h1>
      </div>
    `;
  }
  if (this.order.paymentmethod) {
    content += `
      <div>
            <h5>Payment</h5>
            <p>Payment:${this.order.paymentmethod.payment_method  }</p>
            <p>Amount:${this.order.total_amount  }</p>

          </div>
    `;
  }

  if (this.order.ordernotes) {
    this.order.ordernotes.forEach((item) => {
      if (item.on_receipt) {
    content += `
    <ul class="list-group">
         <li class="list-group-item">${item.note}</li>
    </ul>
    `;
  }
    })
  }

  content += `
  <hr />
    <div class="footer text-capitalize">
     <p> You were served by: <span class="bold">${this.order.soldby.name}</span>
      </p>
  <hr />`;
  if (company.configs !==null) {
  content += `

  <p class="text-justify bold"> ${company.configs}</p>`;
  }
  if (this.storeSettings.receipt_footer_message !==null) {
  content += `
  <div class="footer">
    <small>
      ${this.storeSettings.receipt_footer_message}
    </small>

  </div>
    </div>
  </div>
  </body>
  </html>
  `;
}
}
else{
      content += `
    <div class="order-number">
        <div class="text-center">
            <h4>Kitchen Order</h4>
            <h4>Order Number: ${this.order.order}<br/></h4>
            </div>

      <hr />
       <p> <b>Order By:</b> <span class="bold">${this.order.soldby.name}</span></p>
      Date: ${moment(this.order.created_at).format('D-MM-Y')}</br>

      Time: ${moment(this.order.created_at).format('h:m a')}</br>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th class="quantity">QTY</th>
          <th class="description">Description</th>

        </tr>
      </thead>
      <tbody>
  `;



  this.orderitems.forEach((item) => {
    if(!item.kitchen_status)
  {


  content += `
    <tr>
      <td><p>${item.qty}</p></td>
      <td>
        <p>${item.product ? item.product.product : (item.grouped_inventory ? item.grouped_inventory.group_title : 'N/A')}</p>
        ${
          item.grouped_inventory && item.grouped_inventory.grouped_items ?
          item.grouped_inventory.grouped_items
          .filter(g_item => g_item.product && g_item.product.can_be_sold)
          .map((g_item) => {
            return `
              <p><small>${g_item.product ? g_item.product.product : ''} - ${g_item.count ? g_item.count : ''}</small></p>
            `;
          }).join('') :
          ''
        }
      </td>

    </tr>
    <tr>
      <td colspan="4" style="border-top: 1px dashed #000;"></td>
    </tr>
  `;}
});
}
  return content;
},
generatePrintContentBluetooth() {
    const ESC = "\x1B"; // ESC byte
    const GS = "\x1D";  // GS byte
    const NEW_LINE = "\r\n"; // Ensures compatibility on mobile

    const company = this.user.company;
    let content = `${ESC}!\x01`; // Set smallest font (Font B)

    if (!this.orderitems || this.orderitems.length === 0) {

        return "Error: No items to print";
    }



    // Header: Company details
    if (company) {
        if (company.name) content += `${company.name}${NEW_LINE}`;
        if (company.phone) content += `Phone: ${company.phone}${NEW_LINE}`;
        if (company.email) content += `Email: ${company.email}${NEW_LINE}`;
        if (company.address) content += `Address: ${company.address}${NEW_LINE}`;
        if (company.building) content += `Location: ${company.building}${NEW_LINE}`;
        if (company.street) content += `${company.street}${NEW_LINE}`;
        if (company.town) content += `Town: ${company.town}${NEW_LINE}`;
        if (company.krapin) content += `PIN: ${company.krapin}${NEW_LINE}`;
        content += `--------------------------------${NEW_LINE}`;
    }

    // Customer Details
    if (this.order.customer) {
        content += `Bill To:${NEW_LINE}`;
        content += `Name: ${this.order.customer.full_name}${NEW_LINE}`;
        if (this.order.customer.phone) content += `Phone: ${this.order.customer.phone}${NEW_LINE}`;
        if (this.order.customer.email) content += `Email: ${this.order.customer.email}${NEW_LINE}`;
        content += `--------------------------------${NEW_LINE}`;
    }

    // Order Details
    content += `Order Number: ${this.order.order}${NEW_LINE}`;
    content += `Date: ${moment(this.order.created_at).format('D-MM-Y')}${NEW_LINE}`;
    content += `Time: ${moment(this.order.created_at).format('h:mm a')}${NEW_LINE}`;
    content += `--------------------------------${NEW_LINE}`;

    // Table Headers
    content += `QTY  Description        Price  Total${NEW_LINE}`;
    content += `--------------------------------${NEW_LINE}`;

    // Process Order Items
    let itemLines = "";
    this.orderitems.forEach((item, index) => {


        const qty = item.qty.toString().padEnd(4);
        const desc = (item.product ? item.product.product : 'N/A').substring(0, 15).padEnd(15);
        const price = (
            item.product
                ? (item.is_retail === 1
                    ? item.selling_price ?? item.product.ppu
                    : item.selling_price ?? item.product.wholesale_sp)
                : item.is_retail === 1
                    ? item.selling_price ?? (item.grouped_inventory?.cost ?? 'N/A')
                    : item.selling_price ?? (item.grouped_inventory?.wholesale ?? 'N/A')
        ).toFixed(2).padStart(6);
        const total = (
            (item.product
                ? ((item.is_retail === 1 ? item.selling_price ?? item.product.ppu : item.selling_price ?? item.product.wholesale_sp) * item.qty)
                : ((item.is_retail === 1 ? item.selling_price ?? (item.grouped_inventory?.cost ?? 0) : item.selling_price ?? (item.grouped_inventory?.wholesale ?? 0)) * item.qty)
            )
        ).toFixed(2).padStart(6);

        itemLines += `${qty} ${desc} ${price} ${total}${NEW_LINE}`;
    });

    content += itemLines;
    content += `--------------------------------${NEW_LINE}`;

    // Subtotal, Discount, VAT, and Total
    const subtotal = this.order.total_amount / (this.storeSettings.enable_taxes ? 1.16 : 1);
    const vat = this.order.total_amount - subtotal;

    content += `Subtotal:       ${subtotal.toFixed(2)}${NEW_LINE}`;
    if (this.order.discount) {
        content += `Discount:       ${this.order.discount.toFixed(2)}${NEW_LINE}`;
    }
    if (this.storeSettings.enable_taxes) {
        content += `VAT (16%):      ${vat.toFixed(2)}${NEW_LINE}`;
    }
    if (this.order.partial && this.order.balance > 0) {
        content += `Balance:        ${this.order.balance.toFixed(2)}${NEW_LINE}`;
    }
    content += `Total:          ${this.order.total_amount.toFixed(2)}${NEW_LINE}`;
    content += `--------------------------------${NEW_LINE}`;

    // Payment Details
    if (this.order.paymentmethod) {
        content += `Payment Method: ${this.order.paymentmethod.payment_method}${NEW_LINE}`;
        content += `Amount Paid:    ${this.order.total_amount}${NEW_LINE}`;
    }

    // Notes
    if (this.order.ordernotes) {
        this.order.ordernotes.forEach((note) => {
            if (note.on_receipt) {
                content += `* ${note.note}${NEW_LINE}`;
            }
        });
    }

    content += `--------------------------------${NEW_LINE}`;

    // Footer
    content += `You were served by: ${this.order.soldby.name}${NEW_LINE}`;
    if (company.configs) {
        content += `${company.configs}${NEW_LINE}`;
    }
    if (this.storeSettings.receipt_footer_message) {
        content += `${this.storeSettings.receipt_footer_message}${NEW_LINE}`;
    }

    // Cut Paper Command (for most ESC/POS printers)
    content = content
        .replace(/<br\s*\/?>/g, "\n")  // Replace <br/> or <br> with newline
        .replace(/&nbsp;/g, " ");

    content += `${NEW_LINE.repeat(1)}\x1D\x56\x42\x00 ${ESC}!\x00`;

    return content;
},

sendToThermalPrinter(content) {
        // Use the appropriate code to send the content to the thermal printer
        // For example, you can use a library or API provided by the thermal printer manufacturer
        // Here, we are assuming a hypothetical function `sendToPrinter` is available
        sendToPrinter(content);
      },
      promptEnablePopups() {
  const instructions = `
It seems that pop-ups are blocked. Please enable pop-ups for this site:

- **Google Chrome**:
  1. Click the lock icon next to the address bar.
  2. Go to "Site settings."
  3. Set "Pop-ups and redirects" to "Allow."

- **Mozilla Firefox**:
  1. Click the menu icon (three lines) and select "Settings."
  2. Go to "Privacy & Security."
  3. Under "Permissions," allow pop-ups for this site.

- **Safari**:
  1. Go to Safari > Preferences > Websites.
  2. Select "Pop-up Windows" and allow pop-ups for this site.
`;

  alert(instructions);
},

async printContent(content) {
  const printWindow = window.open("", "_blank");

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();

    //update order items to make them as send to kitchen
    await axios.post('/api/update-kds-order-item',{orderId:this.order.id}).then(results =>{
        console.log(results.status)
    })

  } else {
    this.promptEnablePopups();
  }
},
async printReceiptWithLogo() {
  let base64Logo = '';

  if (this.user.company.logo_url) {
    try {
      base64Logo = await this.fetchImageAsBase64(this.user.company.logo_url);
    } catch (err) {
      console.warn('Logo could not be fetched:', err);
    }
  }

  const content = this.generatePrintContent(base64Logo);
//   this.printContent(content);
},
async fetchImageAsBase64(url) {
  return fetch(url)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.blob();
    })
    .then(blob => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    }));
},


    formatDate(date,format)
    {
        return moment(date).format(format)
    },
      getStoreSettings() {

          this.storeSettings = this.userDetails.company.companysettings;
          this.printInvoice();
      },
    },
  };
  </script>

  <style scoped>
  * {
    box-sizing: border-box;
  }
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 10px;
    line-height: 1.4;
  }
  .container {

    margin: 0 auto;
  }
  .text-center {
    text-align: center;
  }
  .text-justify {
  text-align: justify !important;
}
  .logo {
    text-align: center;
    margin-bottom: 10px;
  }
  .logo img {
    max-width: 120px;
    max-height: 120px;
  }
  .order-number {
    margin-bottom: 10px;
  }
  .table {
    width: 100%;
    margin-bottom: 10px;
  }
  .table th,
  .table td {
    padding: 5px;
    text-align: left;
  }
  .table th,tr {
    border-bottom: 1px solid #000;
    font-weight: normal;
  }

  .totals-row {
    font-weight: normal;
  }
  .footer {
    margin-top: 10px;
    text-align: center;
  }
</style>
